import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import Work from "@/pages/Work";
import Contact from "@/pages/Contact";
import ChatWidget from "@/components/chat/ChatWidget";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/work" element={<Work />} />
          <Route path="/platform" element={<Navigate to="/work" replace />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
